import { render, staticRenderFns } from "./CompanyRatings.vue?vue&type=template&id=1ad3811e"
import script from "./CompanyRatings.vue?vue&type=script&lang=js"
export * from "./CompanyRatings.vue?vue&type=script&lang=js"
import style0 from "./CompanyRatings.vue?vue&type=style&index=0&id=1ad3811e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports